jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});
// Leer más en descripción producto
document.addEventListener('DOMContentLoaded', function() {
  var desc = document.querySelector('.t4s-product__description.t4s-rte');
  if (!desc) return;
  if (!desc.querySelector('h2')) return;

  var btn = document.createElement('button');
  btn.className = 't4s-readmore-btn';
  btn.textContent = 'Leer más';
  desc.parentNode.insertBefore(btn, desc.nextSibling);

  btn.addEventListener('click', function() {
    desc.classList.toggle('is--expanded');
    btn.textContent = desc.classList.contains('is--expanded') ? 'Leer menos' : 'Leer más';
  });
});
// WDS SM · Conectar botón de descripción con el formulario de carrito del tema
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.sm-cta-primario[name="add"]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var form = document.querySelector('form[action="/cart/add"]');
      if (form) {
        var nativeBtn = form.querySelector('[name="add"], [type="submit"]');
        if (nativeBtn) {
          nativeBtn.click();
        }
      }
    });
  });
});